import { Component, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { idMapToArray, ScopeService } from '../../../../../@core/utils/scope.service';
import { NbFormFieldModule, NbInputModule, NbListModule } from '@nebular/theme';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { InvestmentWizardService } from '../../../../../@core/utils/investment-wizard-service';
import { IInvestmentWizard } from '../wizard-interface';
import { KPI } from '../../../../../@core/api';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-wizard-site-selection',
  standalone: true,
  imports: [
    NbListModule,
    CommonModule,
    NbInputModule,
    NbFormFieldModule,
    TranslateModule,
  ],
  template: `
    <div class="flex-grow-1">
      <nb-list>
        <nb-list-item class="pointer" (click)="nextStep(it)" *ngFor="let it of investmentTypes()"
                      [class.selected]="selectedType && selectedType.id === it.id"
                      [class.disabled]="isTypeDisabled(it)">
          <span>
          {{ it.name }}
            </span>
        </nb-list-item>
      </nb-list>
    </div>
  `,
  styleUrls: ['../wizard-index.component.scss'],
})
export class InvestmentTypeSelectionComponent implements OnInit, IInvestmentWizard {
  readonly stateKey = 'INVESTMENT_TYPE_SELECTION';
  state = () => this.wizardService.getState(this.stateKey);
  // service
  private translate = inject(TranslateService);
  // states
  selectedType: KPI.InvestmentType;

  ngOnInit(): void {
    this.selectedType = this.state();
    if (!this.selectedType) {
      this.wizardService.blockCurrentStep(this.translate.instant('Please select a investment type to continue'));
    } else {
      this.wizardService.unblockCurrentStep();
    }
  }

  private scope = inject(ScopeService);
  private wizardService = inject(InvestmentWizardService);

  investmentTypes = toSignal(this.scope.investmentTypes$.pipe(
    idMapToArray(),
    map((types: KPI.InvestmentType[]) => types.sort((a, b) => (a.ordering ?? 0) - (b.ordering ?? 0))),
  ), { initialValue: [] });

  nextStep(it: KPI.InvestmentType) {
    if (this.isTypeDisabled(it)) {
      return;
    }
    this.wizardService.setState(this.stateKey, it);
    this.wizardService.removeStates(['ASSET_SELECTION'])
    this.wizardService.next();
  }

  isTypeDisabled(investmentType: KPI.InvestmentType): boolean {
    const asset = this.wizardService.getState('ORIGIN_ASSET');
    if (!asset) {
      return false;
    }
    if (investmentType.creation_of_equipment) {
      return true;
    }
    if (investmentType.replacement) {
      return !!asset.investments.find((invest: any) => invest.investment_type === investmentType.id);
    }
    return false;
  }
}
